import './sentry.js';
import './polyfills.js';
// import bugsnag from '@bugsnag/js';
// window.bugsnag = bugsnag;

import './responsive-editor-images.js';
import './image-slider.js';
import './prevent-multiple-submit.js';
import './timeline.js';

import './project-search.js';
import './toggle-class.js';

import Alpine from 'alpinejs';
import CookieAccept from '@thinktomorrow/cookie-accept';
import initNotifications from './notification.js';
import initImageSliders from './image-slider.js';
import scaleToFitContainers from './scale-to-fit-container';
import { showElementOnce } from './show-element-once.js';
import { MobileNavigation } from './mobile-navigation.js';
import { lightboxify } from './lightboxify.js';
import { JFS } from 'justforshow';
import initFormFileInputs from './form-file-inputs.js';
import initPreventMultipleSubmits from './prevent-multiple-submit';
import AsyncForm from './async-form';
import initModalIframes from './modal-iframe.js';

// Setting cookiebar cookie
window.CookieAccept = new CookieAccept({
    name: 'legal-cookies',
    days: 365,
    gtmEnabled: true,
});

window.jfs = new JFS(
    [
        {
            name: 'toast',
            styleStart: 'transform: translateY(0)',
            styleEnd: 'transform: translateY(-100%)',
        },
        {
            name: 'handle-animation',
            styleStart:
                'animation: HandleAnimation; animation-duration: 1s; animation-delay: .25s; animation-timing-function: ease; animation; animation-play-state: paused;',
            styleEnd: 'animation-play-state: running;',
        },
        {
            name: 'reveal',
            styleStart: 'transform: translateY(1rem); opacity: 0;',
            styleEnd: 'transform: translateY(0); opacity: 1;',
        },
    ],
    {
        default: {
            name: 'reveal',
            easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
            offset: {
                start: 50,
            },
        },
    }
);

// Should be imported from tailwind config, this is a quick fix
window.breakpoints = {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
};

import './responsive-editor-images.js';
import './prevent-multiple-submit.js';
import './timeline.js';

import './project-search.js';
import './toggle-class.js';

window.addEventListener('DOMContentLoaded', () => {
    lightboxify('[data-lightboxify]', '#lightbox-container', '#lightbox-image');

    MobileNavigation('menu');
    MobileNavigation('phone');

    window.showElementOnce = showElementOnce;

    window.asyncForms.forEach((form) => {
        new AsyncForm(`#${form.id}`, form.options);
    });

    initPreventMultipleSubmits(document);

    scaleToFitContainers();
    initNotifications();
    initImageSliders();
    initFormFileInputs();
    initModalIframes();

    Alpine.start();
});
